// extracted by mini-css-extract-plugin
export default {"header":"aowCT6BSTDZxE_WQoAHw","isOpen":"daBfGiisktUN4xavpxfA","gap":"znvjOR9ZbRQwqjjXj9UN"};